import NavBar from "./reusable-components/nav-bar";
import Rectangle from '../images/Rectangle.png';
import BannerRewards from '../images/BannerRewards.png';
import Button from "react-bootstrap/Button";
import RewardsTab from "./rewardsTab";
import ReferFriendBG from '../images/referFriendBG.png';
import Footer from "./reusable-components/footer";
import ShareWithFriends from '../images/shareWithFriends.png';
function RewardsPage() {
    return (
        <div>
            <div>
                <NavBar />
            </div>
            <div >
                <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
            </div>
            <div>
                <img src={BannerRewards} style={{ width: '100%', height: '200px' }} alt="" />
            </div>
            <div style={{
                marginBottom: '30px'
            }}>
                <div style={{
                    fontFamily: 'Sintony',
                    textAlign: 'center',
                    marginTop: '20px',
                    marginLeft: '20px',
                    marginRight: '20px'
                }}>
                    <span style={{
                        color: '#475666',
                        fontSize: '13px',
                        fontWeight: '700',
                    }}
                    >EARN AS YOU GO</span>
                    <p style={{
                        fontSize: '13px',
                        marginTop: '20px',
                        color: '#475666',
                        lineHeight: '20px',
                        fontWeight: '400'
                    }}>
                        Earn points with each step of your journey and redeem for accessories and upgrades. Refer a friend and earn even more!
                    </p>
                    <Button variant="success" size="lg" type="submit" style={{
                        height: '43px',
                        width: '123px',
                        fontSize: '12px',
                        borderRadius: '0',
                        color: '#FFFFFF',
                        backgroundColor: '#00A78A',
                        borderColor: '#FFFFFF'
                    }} >
                        LEARN MORE
                    </Button>
                </div>
            </div>
            <RewardsTab />
            <div style={{
                height: '250px',
                backgroundImage: `url(${ReferFriendBG})`,
                backgroundRepeat: 'no-repeat'
            }}>
                <div style={{
                    textAlign: 'left',
                    color: '#FFFFFF',
                    paddingTop: '85px',
                    paddingLeft: '20px'
                }}>
                    <div style={{
                        fontSize: '17px',
                        fontWeight: '700',
                        font: 'Sintony',
                        lineHeight: '21px'
                    }}>
                        Refer a friend and <br></br>
                        earn 500 Points!
                    </div>
                    <div style={{
                        marginTop: '10px'
                    }}>
                        <Button variant="outline-secondary" size="lg" type="submit" style={{
                            height: '43px',
                            width: '123px',
                            fontSize: '12px',
                            borderRadius: '0',
                            color: '#FFFFFF',
                            borderColor: '#FFFFFF'
                        }} >
                            LEARN MORE
                        </Button>
                    </div>
                </div>
            </div>
            <div style={{
                fontSize: '14px',
                fontFamily: 'Sintony',
                color: '#475666',
                fontWeight: '700',
                lineHeight: '18.24px',
                textAlign: 'center'
            }}>
                SHARE POINTS WITH A FRIEND
            </div>
            <div>
                <img src={ShareWithFriends} style={{ width: '100%', height: '150px' }} alt="" />
            </div>
            <Footer />
        </div>
    );
}
export default RewardsPage;